// @ts-nocheck
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Focusable } from 'components/focus';
import { useFocusManager } from 'hooks/focus';

import { useVideoById } from 'hooks/video';
import textToSpeechManager from 'support/tts/TextToSpeechManager';
import styles from './UpgradeToWatch.module.scss';

const messages = {
  premiumUpgradeMessage: {
    id: 'upgradeToWatch.tts.message',
    description: 'Upgrade To Watch Message',
  },
};

const UpgradeToWatch = ({ videoId, rowId }) => {
  const intl = useIntl();
  const [video] = useVideoById(videoId, rowId);
  const src = video?.images?.baseImage16X9 || '';
  const providerParamountPlus =
    useSelector(state => state.kitchenSink?.data?.providers?.paramountplus) ||
    {};

  useEffect(() => {
    if (providerParamountPlus) {
      textToSpeechManager.add([
        intl.formatMessage(messages.premiumUpgradeMessage),
        providerParamountPlus.premiumUpgradeMessage,
      ]);
      textToSpeechManager.speak();
    }
  });

  const focusManager = useFocusManager();
  useEffect(() => {
    focusManager.setCurrentFocus('upgrade-to-watch-page');
  }, [focusManager]);

  return (
    <Focusable
      focusId="upgrade-to-watch-page"
      className="w-100 h-100"
      data-testid="upgrade-to-watch-page"
      render={() => (
        <div
          className={classNames(
            'w-100',
            'h-100',
            'd-flex',
            'flex-column',
            'justify-content-center',
            'align-items-center',
            styles.backgroundImage,
          )}
          style={{
            background: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, #000000 100%), url(${src})`,
          }}
        >
          {providerParamountPlus && (
            <div className={styles.title}>
              {providerParamountPlus.premiumUpgradeMessage}
            </div>
          )}
        </div>
      )}
    />
  );
};

UpgradeToWatch.propTypes = {
  videoId: PropTypes.string,
  rowId: PropTypes.string,
};

UpgradeToWatch.defaultProps = {
  videoId: null,
  rowId: null,
};

export default UpgradeToWatch;
